module.exports = __webpack_public_path__ + "static/common-ar-desktop-765665b798d7ca5678c7c07296d4e09e.png";